import React from 'react';

import { SidePage, Section } from '@gogame/components';

import { useLoadSkanSchemeHistory } from 'scenes/SkanSchemes/data';
import { useExportHistorySkanScheme } from 'scenes/SkanSchemes/data/mutations';

import { HistoryTable, Metadata } from './Sections';

const SkanSchemesDetails = ({ onClose, onExited, open, id }) => {
  const { data, isLoading, isRefetching } = useLoadSkanSchemeHistory({
    id,
  });
  const [exportHistorySkanScheme] = useExportHistorySkanScheme();

  const handleExportHistory = (id) => {
    exportHistorySkanScheme({ id });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'SKAN metrics'}
        entityId={id}
        subTitle={data?.name}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent withSidebar={true}>
          <Section title={'History'}>
            <HistoryTable
              data={data?.history?.rows}
              onExport={handleExportHistory}
            />
          </Section>
        </SidePage.NewContent>
        <SidePage.Sidebar>
          <Metadata data={data} />
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default SkanSchemesDetails;
